
export const RoutesPaths = {
  HOME: "/",
  BANNER: "/banner",
  ABOUT: "/about",
  ESG: "/esg",
  CONTACT: "/contact",
  PRIVATE_SECTOR: "/solutions/private-sector",
  PUBLIC_SECTOR: "/solutions/public-sector",
  OURPOSITION: "/ourposition",
  PRIVACY_POLICY: "/privacy-policy",
  TERMS_AND_CONDITIONS: "/terms-and-conditions",
  NOTFOUND: "/not-found",
};
export const backendUrl = "https://api.staging.quimera.ao/api/";
